import Screen from '../../models/screen'
import eventBus from '../../services/event-bus'

export default{
  namespaced: true,
  state: {
    current: null,
    refreshRate: (1000 * 60)
  },
  getters: {
    current: (state) => state.current !== null ? Screen.fromJson(state.current) : null,
    refreshRate: (state) => state.refreshRate
  },
  mutations: {
    SET_CURRENT (state, screen) {
      state.current = screen
    },
    SET_REFRESH_RATE (state, rate) {
      state.refreshRate = rate
    }
  },
  actions: {
    initPusher ({dispatch, commit}) {
      this.$channels.screen.bind('screen-changed', (payload) => {
        console.log('screen changed in store')
        eventBus.$emit('screenUpdated')
        commit('SET_CURRENT', payload.screen)
      })
    },
    async load ({commit}) {
      const screen = await this.$api.getScreen()
      commit('SET_CURRENT', screen)
    },
    async set ({commit}, screen) {
      await this.$api.setScreen(screen)
    },
    async clear ({commit}, screen) {
      await this.$api.setScreen({
        delegate: null,
        association: null,
        motion: null
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/screen.js